/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "EnergySystemParameters": [
      "CoolingParameters",
      "DomesticHotWaterParameters",
      "ElectricityConsumptionParameters",
      "HeatLoadParameters",
      "SpaceHeatingParameters",
      "VentilationParameters"
    ],
    "ProviderParameters": [
      "BatteryParameters",
      "CirculationHeatPumpParameters",
      "CoolingAirHeatPumpParameters",
      "CoolingGroundHeatPumpParameters",
      "HeatBoilerParameters",
      "HeatingAirHeatPumpParameters",
      "HeatingGroundHeatPumpParameters",
      "HybridHeatPumpParameters",
      "InefficientParameters",
      "PreheaterParameters",
      "SolarPanelParameters",
      "WaterCoolingHeatPumpParameters"
    ]
  }
};
      export default result;
    